import {UserRequireModel} from './UserRequireModel'

export const CheckFieldRequire = (data: any) => {
  let arr: string[] = []
  let customerType = data.customerType
  if (customerType) {
    let modelRequire = UserRequireModel.find((o) => o.customerType == customerType)
    if (modelRequire) {
      arr = modelRequire.fieldRequired.filter(
        (o) => data[o] === null || data[o] === '' || (o !== 'customerSegment' && data[o] == '0')
      )
    }
  }
  return arr
}
